import vcfRouterPaths from './vcfRouterPaths';

export default vcfRouterPaths;
